import { EntityModel } from '@/interfaces'
import {
  ALL_TEXT_BLOCKS_QUERY,
  CREATE_TEXT_BLOCK_MUTATION,
  DELETE_TEXT_BLOCK_MUTATION,
  FORCE_DELETE_TEXT_BLOCK_MUTATION,
  SINGLE_TEXT_BLOCK_QUERY,
  UPDATE_TEXT_BLOCK_MUTATION,
} from './graphql'

const cmsTextBlockModel: EntityModel = {
  name: 'textBlock',
  namePlural: 'textBlocks',
  uniqueName: 'cmsTextBlock',
  uniqueNamePlural: 'cmsTextBlocks',
  path: 'cms/blocks/text_block',
  baseUrl: '/cms/blocks/text_blocks',
  translationPrefix: 'entities:cmsTextBlock.',
  getDisplayName: (values: any) => {
    return 'Text block'
  },
  gql: {
    getAll: ALL_TEXT_BLOCKS_QUERY,
    getSingle: SINGLE_TEXT_BLOCK_QUERY,
    create: CREATE_TEXT_BLOCK_MUTATION,
    update: UPDATE_TEXT_BLOCK_MUTATION,
    delete: DELETE_TEXT_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_TEXT_BLOCK_MUTATION,
  },
  attributes: {
    text: {
      name: 'text',
      label: 'entities:cmsTextBlock.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default cmsTextBlockModel
